import { FILTER } from '../../filters/shared/constants';

export const EVENT_PROPERTIES = {
    SOURCE_PAGE: 'Source Page',
    LISTINGS_TYPE: 'Listings Type',
    SEARCH_QUERY: 'Search Query',
    BRAND_NAME: 'Brand Name',
    SLOGAN: 'Slogan',
    INDUSTRY: 'Industry',
    INDUSTRY_COUNT: 'Industry Count',
    KEYWORDS: 'Keywords',
    KEYWORDS_COUNT: 'Keywords Count',
    STYLE: 'Style',
    STYLE_COUNT: 'Style Count',
    ENTRY_POINT_CLICKED: 'Entry point Clicked',
    USER_STATE: 'User State',
    FILTER_LOCATION: 'Filter Location',
    FILTER: 'Filter',
    FILTER_ACTION: 'Filter Action',
    VALUE: 'Value',
    VIA_CAROUSEL: 'Via Carousel',
    CHANGE_LOCATION: 'Change Location',
    FIELD: 'Field',
    LOCATION: 'Location',
    PACKAGE: 'Package',
    LOGO_POSITION: 'Logo Position',
    VARIATION_POSITION: 'Variation Position',
    SELLER_ID: 'Seller ID',
    PROJECT_ID: 'Project ID',
    VARIATION_ID: 'Variation ID',
    ENGINE_TYPE: 'Engine Type',
    ALGO_SOURCE: 'Algo Source',
    SYMBOL_QUALITY: 'Symbol Quality',
    VARIATION_QUALITY: 'Variations Quality',
    RPI: 'RPI',
};

export const FILTER_TYPE = {
    BRAND_NAME: EVENT_PROPERTIES.BRAND_NAME,
    INDUSTRY: EVENT_PROPERTIES.INDUSTRY,
    STYLE: EVENT_PROPERTIES.STYLE,
    ELEMENTS: 'Elements',
};

export const TEXT_FIELDS = {
    BRAND_NAME: EVENT_PROPERTIES.BRAND_NAME,
    SLOGAN: EVENT_PROPERTIES.SLOGAN,
};

export const LOCATION = {
    STATIC: 'Static',
    STICKY: 'Sticky',
};

export const PACKAGE_TYPE = {
    ESSENTIAL: 'Essential',
    PROFESSIONAL: 'Professional',
};

export const FILTER_NAME_BY_TYPE = {
    [FILTER.BRAND_NAME]: 'Brand Name',
    [FILTER.INDUSTRY]: 'Industry',
    [FILTER.LOGO_ELEMENTS]: 'Graphic Elements',
};

export const CTA_LOCATION = {
    STICKY_FILTERS: 'Sticky Filters',
    BOTTOM_OF_LISTING: 'Bottom of Listing',
};
